export default "__VITE_ASSET__DuFlRfF9__"